import { db } from "@/firebase"
import { LEAGUES_ENV, GetLeaguePagePath } from "./utils"

export default {
	toggleMobileNav({ state, commit }) {
		commit("SET_STATE_ITEM", { isMobileNavOpen: !state.isMobileNavOpen })
	},
	hideMobileNav({ commit }) {
		commit("SET_STATE_ITEM", { isMobileNavOpen: false })
	},
	getLeagues({ state, commit, dispatch }) {
		const key = "leagues"
		let listener = state.listeners.find((x) => x.key == key)

		if (!listener) {
			listener = db.collection(LEAGUES_ENV).onSnapshot(
				(snapshot) => {
					let leagues = []

					snapshot.forEach((doc) => {
						leagues.push({
							key: doc.id,
							data: doc.data(),
						})
					})

					commit("SET_STATE_ITEM", { leagues })

					dispatch("loadActivePage")
				},
				(err) => {
					console.log(`ERROR ON LEAGUES SNAPSHOT: ${err}`)
				}
			)

			commit("SET_LISTENER", { key, data: listener })
		}
	},
	setActiveLeague({ commit, dispatch }, activeLeagueKey) {
		commit("SET_STATE_ITEM", { activeLeagueKey })

		dispatch("loadActivePage")
	},
	setActiveTeam({ commit, dispatch }, activeTeamKey) {
		commit("SET_STATE_ITEM", { activeTeamKey })

		dispatch("loadActivePage")
	},
	setActivePage({ commit, dispatch }, activePageName) {
		commit("SET_STATE_ITEM", {
			activePageScheduleWeekId: "",
			activePageAlternateScheduleTeamKey: "",
			activePagePlayoffsBracket: true,
			activePagePlayoffsBracketRound: 0,
			activePageConsolationBracketRound: 0,
			activePageName,
		})

		dispatch("loadActivePage")
	},
	setActivePageScheduleWeekId({ commit }, activePageScheduleWeekId) {
		commit("SET_STATE_ITEM", { activePageScheduleWeekId })
	},
	setActivePageAlternateScheduleTeamKey({ commit }, activePageAlternateScheduleTeamKey) {
		commit("SET_STATE_ITEM", { activePageAlternateScheduleTeamKey })
	},
	setActivePagePlayoffsBracket({ commit }, activePagePlayoffsBracket) {
		commit("SET_STATE_ITEM", { activePagePlayoffsBracket })
	},
	setActivePagePlayoffsBracketRound({ commit }, activePagePlayoffsBracketRound) {
		commit("SET_STATE_ITEM", { activePagePlayoffsBracketRound })
	},
	setActivePageConsolationBracketRound({ commit }, activePageConsolationBracketRound) {
		commit("SET_STATE_ITEM", { activePageConsolationBracketRound })
	},
	loadActivePage({ state, getters, commit }) {
		const key = GetLeaguePagePath(state)

		if (key) {
			let listener = state.listeners.find((x) => x.key == key)

			if (!getters.activePageListener) {
				listener = db.doc(key).onSnapshot(
					(snapshot) => {
						commit("SET_PAGE_DATA", { key, data: snapshot.data() })
					},
					(err) => {
						console.log(`ERROR ON PAGE LISTENER FOR ${key}: ${err}`)
					}
				)

				commit("SET_LISTENER", { key, data: listener })
			}
		}
	},
}
